/*
 * File: d:\projects\AutoFiFront\src\Theme\Component\Paragraphe.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday March 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 13th 2023 5:05:10 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styled from "styled-components";

const ParagrapheStyled = styled.div.attrs(props => ({
    bgColor: props.bgColor,
}))`
&:hover{
    text-decoration: underline ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
}
`

export default ParagrapheStyled;
